import { render } from "./FinalizeShipment.vue?vue&type=template&id=6a8f5638&scoped=true"
import script from "./FinalizeShipment.vue?vue&type=script&lang=js"
export * from "./FinalizeShipment.vue?vue&type=script&lang=js"

import "./FinalizeShipment.vue?vue&type=style&index=0&id=6a8f5638&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8f5638"]])

export default __exports__